module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#politics",
      toString: function () {
        return this.url;
      }
    }